var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative main_box"},[_c('Slider',{attrs:{"ScroY":_vm.ScroY}}),_c('Photos',{attrs:{"ScroY":_vm.ScroY}}),_c('Icons',{attrs:{"ScroY":_vm.ScroY}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }